import React from "react";
import { Checkbox, Spin } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import { LoadingOutlined } from "@ant-design/icons";

interface BooleanCheckboxCellProps {
  /** Current boolean value */
  checked: boolean;
  /** Whether the cell is read-only */
  disabled?: boolean;
  /** Whether the cell is currently saving */
  loading?: boolean;
  /** Callback when checkbox is toggled */
  onChange: (checked: boolean) => void;
  /** Accessible label for screen readers */
  ariaLabel?: string;
}

/**
 * Renders a boolean field as an interactive checkbox with loading state.
 * Used in RelationshipTable for inline editing of boolean properties.
 */
export const BooleanCheckboxCell: React.FC<BooleanCheckboxCellProps> = ({
  checked,
  disabled = false,
  loading = false,
  onChange,
  ariaLabel,
}) => {
  const handleChange = (e: CheckboxChangeEvent) => {
    if (!loading && !disabled) {
      onChange(e.target.checked);
    }
  };

  if (loading) {
    return (
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 14 }} spin />}
        size="small"
      />
    );
  }

  return (
    <Checkbox
      checked={checked}
      disabled={disabled}
      onChange={handleChange}
      aria-label={ariaLabel}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export default BooleanCheckboxCell;
